export const FACETS_KEY = 'f';
export const CATEGORY_SEPARATOR = ' > ';
export const FACET_VALUE_SEPARATOR = '+';

export const FEATURED_BRANDS_KEY = 'Featured Brands';

export const URL_ENCODED = {
    PLUS_SIGN: '%2B',
    BLANK_SPACE: '%20',
    APOSTROPHE: '%27',
};

export const SKIP_VALIDATION_PARAMS = [
    'sortingRule',
    'customBvAverageRating',
    'price.number',
    'query',
    'page',
    'inventory', // store filter: SSR facet list is capped/hit-scoped—would reject valid store IDs
];
